import angular from 'angular';
import booksMenu from '../../menu/Menu';
import ourOrgTemplate from './ourOrg.html';
/** Services */
import { OurOrgServicesProvider } from './services/Services';
import { AppConfigProvider } from './services/AppConfig';
/** Dom */
import { organizationComponent } from './dom/organization/organization';
import { processorsComponent } from './dom/processors/processors';
import {
  AddEditProcessorDialogProvider,
  addEditProcessorDirective
} from './dom/processors/addEditProcessor';
import { openedgeTokensComponent } from './dom/processors/tokens/openedgeTokens';
import { paceTokensComponent } from './dom/processors/tokens/paceTokens';
import { paypalTokensComponent } from './dom/processors/tokens/paypalTokens';
import { payprosTokensComponent } from './dom/processors/tokens/payprosTokens';

/*******************************************************************************
 * @ngdoc overview
 * @name  csm.books.OurOrg
 * @description
 * Our School/PTA/Booster configuration application.
 *******************************************************************************/
export default angular
  .module('csm.books.OurOrg', [
    booksMenu,
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav',
    'ui.grid.resizeColumns'
  ])

  /*****************************************************************************
   * @ngdoc   component
   * @module  csm.books.OurOrg
   * @name    csm.books.OurOrg.component:ourOrg
   *
   * @description
   * This component creates the tabs and content for ourOrg by utilizing the
   * organization and processors components. Additional tabs and components can
   * be added in the AppConfig provider.
   *****************************************************************************/
  .component('ourOrg', {
    template: ourOrgTemplate,
    controller: ourOrgController
  })

  /*****************************************************************************
   * @ngdoc   directive
   * @module  csm.books.OurOrg
   * @name    csm.books.OurOrg.directive:onShown
   *
   * @description
   * This is a directive that is used to let the components know when a tab has been
   * selected. This is used because there is a problem with the timing between
   * when the grid is rendered vs when the grid is actually shown. This allows us
   * to render the grid when the tab is selected.
   *****************************************************************************/
  .directive('onShown', onShownDirective)
  .provider('Services', OurOrgServicesProvider)
  .provider('AppConfig', AppConfigProvider)
  .component('organization', organizationComponent)
  .provider('AddEditProcessorDialog', AddEditProcessorDialogProvider)
  .directive('addEditProcessorComponent', addEditProcessorDirective)
  .component('processors', processorsComponent)
  .component('openedgeTokens', openedgeTokensComponent)
  .component('paceTokens', paceTokensComponent)
  .component('paypalTokens', paypalTokensComponent)
  .component('payprosTokens', payprosTokensComponent).name;

/* @ngInject */ function ourOrgController($rootScope, AppConfig, SERVER) {
  Object.assign($rootScope, {
    AppConfig: AppConfig,
    BooksDBConstants: SERVER.BooksDBConstants
  });
}

/* @ngInject */ function onShownDirective($rootScope) {
  return {
    restrict: 'A',
    link: function (scope, elem) {
      elem.on('shown.bs.tab', function () {
        $rootScope.$broadcast('shown.bs.tab');
      });
    }
  };
}
